<div *ngIf="opportunity">

    <div *ngIf="!showSummary" class="order-booking-header">
        <div class="order-booking-header-inner">
            <div class="header-left">
                <div class="page-name">Book My Shipment</div>
                <div class="page-description">Fill out the form below to book your transportation order</div>
                <div class="nav-container transitions-list">
                    <ng-container *ngFor="let page of pages; let i = index">
                        <span [attr.data-stage-index]="i" [ngClass]="{ 'selected-stage': i === currentPage - 1, 'start-stage': i === 0, 'final-stage': i === pages.length - 1, 'current-transaction': i === currentPage - 1, 'future-transaction': i > currentPage - 1 }"
                                class="stage-list-transition">
                            {{ page.title }}
                        </span>
                        <span *ngIf="i < pages.length - 1" class="stage-list-transition-delimeter">&gt;</span>
                    </ng-container>
                </div>
            </div>
            <div class="header-right">
                <div class="header-right-quote">Quote</div>
                <div class="header-right-number">#{{ opportunity?.id }}</div>
                <div class="header-right-price-header">Price expiration Date</div>
                <div class="header-right-price-expiration-date">
                    {{ opportunity?.priceExpirationDate | date:'MM/dd/yyyy' }}
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!showSummary" class="order-booking-transition-mobile">
        <div class="nav-container transitions-list">
            <ng-container *ngFor="let page of pages; let i = index">
                <span [attr.data-stage-index]="i" [ngClass]="{ 'selected-stage': i === currentPage - 1, 'start-stage': i === 0, 'final-stage': i === pages.length - 1, 'current-transaction': i === currentPage - 1, 'future-transaction': i > currentPage - 1 }"
                        class="stage-list-transition">
                    {{ page.titleMobile || page.title }}
                </span>
                <span *ngIf="i < pages.length - 1" class="stage-list-transition-delimeter">&gt;</span>
            </ng-container>
        </div>
    </div>
    <div *ngIf="!showSummary" class="order-booking-main order-booking-main-top-header">
        <div class="order-booking-main-inner">
            <form
                *ngIf="customerForm"
                [formGroup]="customerForm"
                class="order-booking-main-left order-booking-main-left-container">

                <div class="transaction-stage" [ngClass]="{ 'selected-stage': currentPage === 1 }">
                    <div class="mb-4">
                        <div class="header-block">
                            <div class="header-block__header">Contact info</div>
                        </div>

                        <!-- First Name -->
                        <div class="border-container form-field-container">
                            <span [ngClass]="{ 'hide-label': !customerControls.firstName.value, 'show-label': customerControls.firstName.value }"
                                    class="border-text">First Name</span>
                            <input
                                id="customerFirstName"
                                name="customerFirstName"
                                autocomplete="given-name"
                                [formControl]="customerControls.firstName"
                                [maxlength]="maxLengths.Name"
                                class="form-control"
                                placeholder="First Name">
                            <span
                                *ngIf="customerControls.firstName.invalid && showFormErrors"
                                class="text-danger">
                                First name is required
                            </span>
                        </div>

                        <!-- Last Name -->
                        <div class="mt-4 border-container form-field-container">
                            <span [ngClass]="{ 'hide-label': !customerControls.lastName.value, 'show-label': customerControls.lastName.value }"
                                    class="border-text">Last Name</span>
                            <input
                                id="customerLastName"
                                name="customerLastName"
                                autocomplete="family-name"
                                [formControl]="customerControls.lastName"
                                [maxlength]="maxLengths.Name"
                                class="form-control"
                                placeholder="Last Name">
                            <span
                                *ngIf="customerControls.lastName.invalid && showFormErrors"
                                class="text-danger">
                                Last name is too long
                            </span>
                        </div>

                        <!-- Add Company Name Button -->
                        <app-add-new-input-field
                            [formControlInput]="customerControls.company"
                            inputId="customerCompany"
                            autocomplete="organization"
                            [initiallyVisible]="!!customerControls.company.value"
                            [maxLength]="maxLengths.Company"
                            buttonLabel="Add Company"
                            inputPlaceholder="Company"
                        ></app-add-new-input-field>

                        <!-- Email -->
                        <div class="mt-4 border-container form-field-container">
                            <span [ngClass]="{ 'hide-label': !customerControls.email.value, 'show-label': customerControls.email.value }"
                                    class="border-text">Email</span>
                            <input
                                id="customerEmail"
                                name="customerEmail"
                                autocomplete="email"
                                [formControl]="customerControls.email"
                                [maxlength]="maxLengths.Email"
                                class="form-control"
                                placeholder="Email">
                            <span
                                *ngIf="customerControls.email.invalid && (customerControls.email.dirty || customerControls.email.touched || showFormErrors)"
                                class="text-danger">
                                <ng-container *ngIf="customerControls.email.errors?.['required'] && showFormErrors">Email is required</ng-container>
                                <ng-container *ngIf="customerControls.email.errors?.['email']">Please enter a valid email address.</ng-container>
                            </span>
                        </div>

                        <!-- Add Another Email Button -->
                        <app-add-new-input-field
                            [formControlInput]="customerControls.email2"
                            inputId="customerEmail2"
                            [initiallyVisible]="!!customerControls.email2.value"
                            [maxLength]="maxLengths.Email"
                            [showErrors]="showFormErrors"
                            [errorMessages]="{ email: 'Please enter a valid email address.' }"
                            buttonLabel="Add Another Email"
                            inputPlaceholder="Additional Email"
                        ></app-add-new-input-field>

                        <!-- Phone (read-only; managed by sales agent) -->
                        <div class="mt-4 border-container form-field-container phone-readonly-wrapper" [attr.data-tooltip]="phoneDisabledTooltip">
                            <span [ngClass]="{ 'hide-label': !customerControls.phone.value, 'show-label': customerControls.phone.value }"
                                    class="border-text">Phone</span>
                            <input
                                id="customerPhone"
                                name="customerPhone"
                                autocomplete="off"
                                [formControl]="customerControls.phone"
                                [maxlength]="maxLengths.Phone"
                                class="form-control"
                                placeholder="Phone">
                        </div>

                        <app-add-new-input-field
                            [formControlInput]="customerControls.phone2"
                            inputId="customerPhone2"
                            [initiallyVisible]="!!customerControls.phone2.value"
                            [maxLength]="maxLengths.Phone"
                            (inputAdded)="isPhone2Added = true"
                            buttonLabel="Add Another Phone"
                            inputPlaceholder="Additional Phone"
                        ></app-add-new-input-field>

                        <app-add-new-input-field
                            *ngIf="isPhone2Added"
                            [formControlInput]="customerControls.fax"
                            inputId="customerFax"
                            [initiallyVisible]="!!customerControls.fax.value"
                            [maxLength]="maxLengths.Fax"
                            buttonLabel="Add Another Phone"
                            inputPlaceholder="Additional Phone 2"
                        ></app-add-new-input-field>

                        <!-- First Available Pickup Date -->
                        <div class="mt-4 border-container form-field-container">
                            <span [ngClass]="{ 'hide-label': !customerControls.firstAvailablePickup.value, 'show-label': customerControls.firstAvailablePickup.value }"
                                    class="border-text">First Available Pickup Date</span>
                            <app-date-input
                                inputId="FirstAvailablePickupDate"
                                minDateMode="today"
                                [formControl]="customerControls.firstAvailablePickup">
                            </app-date-input>
                            <span *ngIf="customerControls.firstAvailablePickup.invalid && showFormErrors" class="text-danger">
                                <ng-container *ngIf="customerControls.firstAvailablePickup.errors?.['required']">First Available Pickup Date is required</ng-container>
                                <ng-container *ngIf="customerControls.firstAvailablePickup.errors?.['invalidDate']">Please enter a valid date (MM/DD/YYYY)</ng-container>
                                <ng-container *ngIf="customerControls.firstAvailablePickup.errors?.['dateBeforeMin']">Pickup date cannot be in the past</ng-container>
                            </span>
                        </div>

                        <!-- Special Terms -->
                        <div *ngIf="customerControls.specialTerms.value">
                            <div class="mt-4 border-container">
                                <span class="border-text show-label">Special Terms</span>
                                <app-terms-display
                                    inputId="specialTerms"
                                    [value]="customerControls.specialTerms.value">
                                </app-terms-display>
                            </div>
                        </div>

                        <!-- Note -->
                        <div *ngIf="displayShipperNote">
                            <div class="mt-4 mb-4">
                                <div class="mt-4 border-container">
                                    <span class="border-text show-label">Note</span>
                                    <app-terms-display
                                        inputId="commentFromShipper"
                                        [value]="customerControls.commentFromShipper.value">
                                    </app-terms-display>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="transaction-stage" [ngClass]="{ 'selected-stage': currentPage === 2 }">
                    <div class="mb-4">
                        <div class="header-block">
                            <div class="header-block__header">origin</div>
                            <div class="header-block__desc">This is the pickup location.</div>
                        </div>

                        <!-- Address -->
                        <div class="mt-4 border-container form-field-container">
                            <span [ngClass]="{ 'hide-label': !originControls.address.value, 'show-label': originControls.address.value }"
                                    class="border-text">Origin Address</span>
                            <input
                                id="originAddress"
                                name="originAddress"
                                autocomplete="section-origin shipping address-line1"
                                [formControl]="originControls.address"
                                [maxlength]="maxLengths.Address"
                                class="form-control"
                                placeholder="Origin Address">
                            <span *ngIf="originControls.address.invalid && showFormErrors" class="text-danger">
                                {{ originControls.address.errors?.['required'] ? 'Address is required' : '' }}
                            </span>
                        </div>

                        <!-- Add another Address Line -->
                        <app-add-new-input-field
                            [formControlInput]="originControls.address2"
                            inputId="originAddress2"
                            autocomplete="section-origin shipping address-line2"
                            [initiallyVisible]="!!originControls.address2.value"
                            [maxLength]="maxLengths.Address"
                            buttonLabel="Add Another Address Line"
                            inputPlaceholder="Origin Address"
                        ></app-add-new-input-field>

                        <!-- Origin City -->
                        <div class="mt-4 border-container form-field-container">
                            <span [ngClass]="{ 'hide-label': !originControls.userFriendlyAddress.value, 'show-label': originControls.userFriendlyAddress.value }"
                                    class="border-text">Origin City</span>
                            <input
                                id="originCity"
                                name="originCity"
                                autocomplete="off"
                                [formControl]="originControls.userFriendlyAddress"
                                class="form-control"
                                placeholder="Origin City">
                        </div>

                        <!-- Origin Contact -->
                        <div class="header-block mt-4">
                            <div class="header-block__header">Origin contact</div>
                            <div class="header-block__desc">This is the person that we will contact on the day of the pickup
                                to make
                                arrangements.
                            </div>
                        </div>
                        <div class="mt-4">
                            <div class="form-check">
                                <input
                                    [formControl]="originControls.iAmPickupContact"
                                    class="form-check-input"
                                    id="originPickupCheck"
                                    type="checkbox">
                                <label class="form-check-label" for="originPickupCheck">
                                    I Am The Pickup Contact
                                </label>
                            </div>
                        </div>

                        <div id="originCheckboxInputs">
                            <!-- Origin Contact Name -->
                            <div class="mt-4 border-container form-field-container">
                                <span [ngClass]="{ 'hide-label': !originControls.contactName.value, 'show-label': originControls.contactName.value }"
                                        class="border-text">Origin Contact Name</span>
                                <input
                                    id="originContactName"
                                    name="originContactName"
                                    autocomplete="section-origin shipping name"
                                    [formControl]="originControls.contactName"
                                    [maxlength]="maxLengths.ContactName"
                                    class="form-control"
                                    placeholder="Origin Contact Name">
                                <span *ngIf="originControls.contactName.invalid && showFormErrors" class="text-danger"></span>
                            </div>

                            <!-- Origin Contact Email -->
                            <div class="mt-4 border-container form-field-container">
                                <span [ngClass]="{ 'hide-label': !originControls.contactEmail.value, 'show-label': originControls.contactEmail.value }"
                                        class="border-text">Origin Contact Email</span>
                                <input
                                    id="originContactEmail"
                                    name="originContactEmail"
                                    autocomplete="section-origin shipping email"
                                    [formControl]="originControls.contactEmail"
                                    [maxlength]="maxLengths.Email"
                                    class="form-control"
                                    placeholder="Origin Contact Email">
                                <span *ngIf="originControls.contactEmail.invalid && (originControls.contactEmail.dirty || originControls.contactEmail.touched)" class="text-danger">
                                    <ng-container *ngIf="originControls.contactEmail.errors?.['email']">Please enter a valid email address.</ng-container>
                                </span>
                            </div>

                            <!-- Origin Contact Phone -->
                            <div class="mt-4 border-container form-field-container">
                                <span [ngClass]="{ 'hide-label': !originControls.contactPhone.value, 'show-label': originControls.contactPhone.value }"
                                        class="border-text">Origin Contact Phone</span>
                                <input
                                    id="originContactPhone"
                                    name="originContactPhone"
                                    autocomplete="section-origin shipping tel"
                                    [formControl]="originControls.contactPhone"
                                    [maxlength]="maxLengths.Phone"
                                    class="form-control"
                                    placeholder="Origin Contact Phone">
                                <span *ngIf="originControls.contactPhone.invalid && showFormErrors" class="text-danger"></span>
                            </div>
                        </div>

                        <!-- Add Another Phone Button (2) -->
                        <app-add-new-input-field
                            [formControlInput]="originControls.contactPhone2"
                            inputId="originContactPhone2"
                            [initiallyVisible]="!!originControls.contactPhone2.value"
                            [maxLength]="maxLengths.Phone"
                            (inputAdded)="isOriginContactPhone2Added = true"
                            buttonLabel="Add Another Phone"
                            inputPlaceholder="Additional Phone"
                        ></app-add-new-input-field>

                        <!-- Add Another Phone Button (3) -->
                        <app-add-new-input-field
                            *ngIf="isOriginContactPhone2Added"
                            [formControlInput]="originControls.contactPhone3"
                            inputId="originContactPhone3"
                            [initiallyVisible]="!!originControls.contactPhone3.value"
                            [maxLength]="maxLengths.Phone"
                            (inputAdded)="isOriginContactPhone3Added = true"
                            buttonLabel="Add Another Phone"
                            inputPlaceholder="Additional Phone 2"
                        ></app-add-new-input-field>

                        <!-- Add Another Phone Button (4) -->
                        <app-add-new-input-field
                            *ngIf="isOriginContactPhone3Added"
                            [formControlInput]="originControls.contactPhoneCell"
                            inputId="originContactPhoneCell"
                            [initiallyVisible]="!!originControls.contactPhoneCell.value"
                            [maxLength]="maxLengths.Phone"
                            buttonLabel="Add Another Phone"
                            inputPlaceholder="Additional Phone 3"
                        ></app-add-new-input-field>
                    </div>
                </div>

                <div class="transaction-stage" [ngClass]="{ 'selected-stage': currentPage === 3 }">
                    <div class="mb-4">
                        <div class="header-block">
                            <div class="header-block__header">Destination</div>
                            <div class="header-block__desc">This is the delivery location.</div>
                        </div>

                        <!-- Address -->
                        <div class="mt-4 border-container form-field-container">
                            <span [ngClass]="{ 'hide-label': !destinationControls.address.value, 'show-label': destinationControls.address.value }"
                                    class="border-text">Destination Address</span>
                            <input
                                id="destinationAddress"
                                name="destinationAddress"
                                autocomplete="section-destination shipping address-line1"
                                [formControl]="destinationControls.address"
                                [maxlength]="maxLengths.Address"
                                class="form-control"
                                placeholder="Destination Address">
                            <span *ngIf="destinationControls.address.invalid && showFormErrors" class="text-danger"></span>
                        </div>

                        <!-- Add another Address Line -->
                        <app-add-new-input-field
                            [formControlInput]="destinationControls.address2"
                            inputId="destinationAddress2"
                            autocomplete="section-destination shipping address-line2"
                            [initiallyVisible]="!!destinationControls.address2.value"
                            [maxLength]="maxLengths.Address"
                            buttonLabel="Add Another Address Line"
                            inputPlaceholder="Destination Address"
                        ></app-add-new-input-field>

                        <!-- Destination City -->
                        <div class="mt-4 border-container form-field-container">
                            <span [ngClass]="{ 'hide-label': !destinationControls.userFriendlyAddress.value, 'show-label': destinationControls.userFriendlyAddress.value }"
                                    class="border-text">Destination City</span>
                            <input
                                id="destinationCity"
                                name="destinationCity"
                                autocomplete="off"
                                [formControl]="destinationControls.userFriendlyAddress"
                                class="form-control"
                                placeholder="Destination City">
                        </div>

                        <!-- Destination Contact -->
                        <div class="header-block mt-4">
                            <div class="header-block__header">Destination contact</div>
                            <div class="header-block__desc">This is the person that we will contact on the day of the
                                delivery to make arrangements.
                            </div>
                        </div>
                        <div class="mt-4">
                            <div class="form-check">
                                <input
                                    [formControl]="destinationControls.iAmPickupContact"
                                    class="form-check-input"
                                    id="destinationPickupCheck"
                                    type="checkbox">
                                <label class="form-check-label" for="destinationPickupCheck">
                                    I Am The Destination Contact
                                </label>
                            </div>
                        </div>

                        <div id="destinationCheckboxInputs">
                            <!-- Destination Contact Name -->
                            <div class="mt-4 border-container form-field-container">
                                <span [ngClass]="{ 'hide-label': !destinationControls.contactName.value, 'show-label': destinationControls.contactName.value }"
                                        class="border-text">Destination Contact Name</span>
                                <input
                                    id="destinationContactName"
                                    name="destinationContactName"
                                    autocomplete="section-destination shipping name"
                                    [formControl]="destinationControls.contactName"
                                    [maxlength]="maxLengths.ContactName"
                                    class="form-control"
                                    placeholder="Destination Contact Name">
                                <span *ngIf="destinationControls.contactName.invalid && showFormErrors" class="text-danger"></span>
                            </div>

                            <!-- Destination Contact Email -->
                            <div class="mt-4 border-container form-field-container">
                                <span [ngClass]="{ 'hide-label': !destinationControls.contactEmail.value, 'show-label': destinationControls.contactEmail.value }"
                                        class="border-text">Destination Contact Email</span>
                                <input
                                    id="destinationContactEmail"
                                    name="destinationContactEmail"
                                    autocomplete="section-destination shipping email"
                                    [formControl]="destinationControls.contactEmail"
                                    [maxlength]="maxLengths.Email"
                                    class="form-control"
                                    placeholder="Destination Contact Email">
                                <span *ngIf="destinationControls.contactEmail.invalid && (destinationControls.contactEmail.dirty || destinationControls.contactEmail.touched)" class="text-danger">
                                    <ng-container *ngIf="destinationControls.contactEmail.errors?.['email']">Please enter a valid email address.</ng-container>
                                </span>
                            </div>

                            <!-- Destination Contact Phone -->
                            <div class="mt-4 border-container form-field-container">
                                <span [ngClass]="{ 'hide-label': !destinationControls.contactPhone.value, 'show-label': destinationControls.contactPhone.value }"
                                        class="border-text">Destination Contact Phone</span>
                                <input
                                    id="destinationContactPhone"
                                    name="destinationContactPhone"
                                    autocomplete="section-destination shipping tel"
                                    [formControl]="destinationControls.contactPhone"
                                    [maxlength]="maxLengths.Phone"
                                    class="form-control"
                                    placeholder="Destination Contact Phone">
                                <span *ngIf="destinationControls.contactPhone.invalid && showFormErrors" class="text-danger"></span>
                            </div>
                        </div>

                        <!-- Add Another Phone Button (2) -->
                        <app-add-new-input-field
                            [formControlInput]="destinationControls.contactPhone2"
                            inputId="destinationContactPhone2"
                            [initiallyVisible]="!!destinationControls.contactPhone2.value"
                            [maxLength]="maxLengths.Phone"
                            (inputAdded)="isDestinationContactPhone2Added = true"
                            buttonLabel="Add Another Phone"
                            inputPlaceholder="Additional Phone"
                        ></app-add-new-input-field>

                        <!-- Add Another Phone Button (3) -->
                        <app-add-new-input-field
                            *ngIf="isDestinationContactPhone2Added"
                            [formControlInput]="destinationControls.contactPhone3"
                            inputId="destinationContactPhone3"
                            [initiallyVisible]="!!destinationControls.contactPhone3.value"
                            [maxLength]="maxLengths.Phone"
                            (inputAdded)="isDestinationContactPhone3Added = true"
                            buttonLabel="Add Another Phone"
                            inputPlaceholder="Additional Phone 2"
                        ></app-add-new-input-field>

                        <!-- Add Another Phone Button (4) -->
                        <app-add-new-input-field
                            *ngIf="isDestinationContactPhone3Added"
                            [formControlInput]="destinationControls.contactPhoneCell"
                            inputId="destinationContactPhoneCell"
                            [initiallyVisible]="!!destinationControls.contactPhoneCell.value"
                            [maxLength]="maxLengths.Phone"
                            buttonLabel="Add Another Phone"
                            inputPlaceholder="Additional Phone 3"
                        ></app-add-new-input-field>
                    </div>
                </div>

                <div *ngIf="paymentStepRequired" class="transaction-stage" [ngClass]="{ 'selected-stage': currentPage === 4 }">
                    <div *ngIf="!customerHasCreditCard else skipBillingContainer" id="commonBillingContainer">
                        <div class="mb-4">
                            <div class="header-block">
                                <div class="header-block__header">Billing information</div>
                                <div class="mt-2 header-block__desc"><span class="info_important">*</span>This address must
                                    match the billing address for your credit card otherwise we will not be able to process
                                    your order.
                                </div>
                            </div>

                            <button
                                class="btn__dropdown"
                                type="button"
                                (click)="toggleAddressDropdown()">
                                <div class="btn__base--left"><i class="fa-solid fa-location-dot"></i><span
                                    id="orderBookingSelectedAddress">
                                    {{ selectedAddress }}
                                </span></div>
                                <div class="btn__base--right"><i class="fa-solid fa-chevron-down"></i></div>
                            </button>
                            <ul aria-labelledby="orderBookingAddressDropdown" class="dropdown-menu"
                                id="orderBookingAddressMenu"
                                [ngClass]="{ 'show': addressDropdownOpened }"
                                *ngIf="addressDropdownOpened">
                                <li>
                                    <button (click)="setMyAddressAsBillingAddress()" class="dropdown-item" type="button">My Address
                                    </button>
                                </li>
                                <li>
                                    <button (click)="setOriginAsBillingAddress()" class="dropdown-item" type="button">Origin Address
                                    </button>
                                </li>
                                <li>
                                    <button (click)="setDestinationAsBillingAddress()" class="dropdown-item" type="button">
                                        Destination Address
                                    </button>
                                </li>
                            </ul>

                            <div id="orderBookingMyAddressContainer">
                                <!-- Address -->
                                <div class="mt-4 border-container form-field-container">
                                    <span [ngClass]="{ 'hide-label': !creditCardControls.address.value, 'show-label': creditCardControls.address.value }"
                                            class="border-text">Billing Address</span>
                                    <input
                                        id="billingAddress"
                                        name="billingAddress"
                                        autocomplete="billing address-line1"
                                        [formControl]="creditCardControls.address"
                                        [maxlength]="maxLengths.Address"
                                        class="form-control"
                                        placeholder="Billing Address">
                                    <span *ngIf="creditCardControls.address.invalid && showFormErrors" class="text-danger">
                                        Billing address is required
                                    </span>
                                </div>

                                <!-- City -->
                                <div class="mt-4 border-container form-field-container">
                                    <span [ngClass]="{ 'hide-label': !creditCardControls.city.value, 'show-label': creditCardControls.city.value }"
                                            class="border-text">City</span>
                                    <input
                                        id="billingCity"
                                        name="billingCity"
                                        autocomplete="billing address-level2"
                                        [formControl]="creditCardControls.city"
                                        [maxlength]="maxLengths.City"
                                        class="form-control"
                                        placeholder="City">
                                    <span *ngIf="creditCardControls.city.invalid && showFormErrors" class="text-danger">
                                        City is required
                                    </span>
                                </div>

                                <!-- State/Province -->
                                <div class="mt-4 border-container form-field-container">
                                    <span [ngClass]="{ 'hide-label': !creditCardControls.state.value, 'show-label': creditCardControls.state.value }"
                                            class="border-text">State/Province (two letter code)</span>
                                    <input
                                        id="billingState"
                                        name="billingState"
                                        autocomplete="billing address-level1"
                                        [formControl]="creditCardControls.state"
                                        maxlength="2"
                                        class="form-control text-uppercase"
                                        placeholder="State/Province (two letter code)"
                                        (input)="onCreditCardStateInput($event)">
                                    <span *ngIf="creditCardControls.state.invalid && showFormErrors" class="text-danger">
                                        Enter a 2-letter state/province code
                                    </span>
                                </div>

                                <!-- Zip/Postal Code -->
                                <div class="mt-4 border-container form-field-container">
                                    <span [ngClass]="{ 'hide-label': !creditCardControls.postalCode.value, 'show-label': creditCardControls.postalCode.value }"
                                            class="border-text">Zip/Postal Code</span>
                                    <input
                                        id="billingPostalCode"
                                        name="billingPostalCode"
                                        autocomplete="billing postal-code"
                                        [formControl]="creditCardControls.postalCode"
                                        [maxlength]="maxLengths.PostalCode"
                                        class="form-control"
                                        placeholder="Zip/Postal Code">
                                    <span *ngIf="creditCardControls.postalCode.invalid && showFormErrors" class="text-danger">
                                        Zip/Postal code is required
                                    </span>
                                </div>

                                <!-- Country -->
                                <div class="mt-4 border-container form-field-container">
                                    <span class="border-text show-label">Country</span>
                                    <select
                                        id="billingCountry"
                                        name="billingCountry"
                                        autocomplete="billing country"
                                        [formControl]="creditCardControls.country"
                                        class="form-control">
                                        <option *ngFor="let country of countriesList" [value]="country.countryCode">
                                            {{ country.countryName }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Credit card information -->
                            <div class="header-block mt-4">
                                <div class="header-block__header">Credit card information</div>
                                <div class="header-block__desc">
                                    <span class="info_important">* </span>
                                    Credit information is required to book the order, but your credit card will not be
                                    charged right now. We do
                                    not keep a record of your credit card information for security purposes. All information
                                    is encrypted using
                                    strongest encryption technology available. We will process a charge to your credit card
                                    based on the payment
                                    terms on the previous page.
                                </div>
                            </div>

                            <!-- Accepted credit cards -->
                            <div class="payment-container mt-4">
                                <label class="form-label credit-card-label">Accepted credit cards</label>
                                <div class="credit-cards-list">
                                    <img *ngFor="let card of acceptedCreditCards" [alt]="card.alt" [src]="card.src">
                                </div>
                            </div>

                            <!-- Payment Card Input Wrapper (Stripe/PayPal/etc.) -->
                            <!-- showCardHolderName=true means the component will render the cardholder name field -->
                            <div class="mt-4">
                                <app-payment-card-input-wrapper
                                    *ngIf="merchantPlatform"
                                    [merchantPlatform]="merchantPlatform"
                                    [showFormErrors]="showFormErrors"
                                    [showCardHolderName]="true">
                                </app-payment-card-input-wrapper>
                            </div>
                        </div>
                    </div>

                    <ng-template #skipBillingContainer>
                        <div class="mb-4">
                            <div class="header-block">
                                <div class="header-block__header">Billing information</div>
                            </div>
                            <!-- Credit card information -->
                            <div class="mt-4">
                                <div class="header-block__header">Credit card information</div>
                                <div class="header-block__desc">
                                    <span class="info_important">* </span>
                                    Credit information is required to book the order, but your credit card will not be
                                    charged right now. We do
                                    not keep a record of your credit card information for security purposes. All information
                                    is encrypted using
                                    strongest encryption technology available. We will process a charge to your credit card
                                    based on the payment
                                    terms in the price section.
                                </div>
                            </div>
                            <br/>
                            <br/>
                            <div class="header-block">
                                <div class="header-block__desc">
                                    <p>
                                        We already have a credit card on file ending in <b
                                        id="savedCustomerLastFourcc">{{ opportunity?.customer?.creditCardNumber }}</b>.
                                        If you wish to change the billing card please contact
                                        your agent and request from them to remove the existing card first.
                                        Then you will be able to input new credit card information.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>

                <div class="transaction-stage" [ngClass]="{ 'selected-stage': currentPage === pages.length }">
                    <div class="mb-4">
                        <div class="header-block">
                            <div class="header-block__header">Acceptance</div>
                            <div class="header-block__desc"><span class="info_important">*</span>By selecting "I Agree" and
                                entering my full name as a binding electronic signature, I understand that an electronic
                                signature has the same legal effect and can be enforced
                                in the same way as a written signature. Furthermore, I hereby accept terms and conditions of
                                service as described in the "Terms & Conditions" section below.
                            </div>
                        </div>

                                <!-- Terms and conditions -->
                                <div class="info-block__acceptance overflow-auto">
                                    <div class="info-block__main">
                                        <div class="content-wrapper">
                                            <div class="info-block__row--big">
                                                <span class="info-block__row__header terms-header">Terms & Conditions</span>
                                            </div>
                                            <div class="info-block__column__tip  remove-border">
                                                <span [innerHTML]="terms"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                        <!-- Agree checkbox -->
                        <div class="mt-4">
                            <div class="form-check">
                                <input
                                    [formControl]="signatureControls.agree"
                                    class="form-check-input"
                                    id="IAgreeCheckbox"
                                    type="checkbox">
                                <label class="form-check-label" for="IAgreeCheckbox">
                                    I Agree
                                </label>
                            </div>
                        </div>


                        <div *ngIf="signatureControls.agree.value">
                            <!-- Electronic signature -->
                            <div class="mt-4 border-container form-field-container">
                                <span [ngClass]="{ 'hide-label': !signatureControls.signedBy.value, 'show-label': signatureControls.signedBy.value }"
                                        class="border-text">Electronic signature (Your full name)</span>
                                <app-signature-input
                                    inputId="signedBy"
                                    placeholder="Electronic signature (Your full name)*"
                                    [showFormErrors]="showFormErrors"
                                    [externalControl]="signatureControls.signedBy"
                                    [formControl]="signatureControls.signedBy">
                                </app-signature-input>
                            </div>

                            <!-- IP address -->
                            <div class="mt-4 border-container form-field-container">
                                <span [ngClass]="{ 'hide-label': !signatureControls.ip.value, 'show-label': signatureControls.ip.value }"
                                        class="border-text">Your IP address</span>
                                <input [formControl]="signatureControls.ip" class="form-control" id="sigIpAddress"
                                        type="text"/>
                            </div>

                            <!-- Date -->
                            <div class="mt-4 border-container form-field-container">
                                <span [ngClass]="{ 'hide-label': !signatureControls.signedOn.value, 'show-label': signatureControls.signedOn.value }"
                                        class="border-text">Agreed to terms on this day</span>
                                <input [formControl]="signatureControls.signedOn" class="form-control" id="disabledAgreedToTerms"
                                        type="text">
                            </div>
                        </div>
                    </div>

                        </div>

                    </form>

            <div class="order-booking-main-right">
                <app-price-and-cargo
                    [bookingPrice]="opportunity?.price"
                    [transportType]="opportunity?.transportType"
                    [vehicles]="opportunity?.vehicles"
                ></app-price-and-cargo>
            </div>

            <div class="order-booking-main-left order-booking-main-left-container">
                <div class="order-booking-main-button">
                    <!-- Previous Button: Show on all pages except first -->
                    <button
                            (click)="goToPreviousStage()"
                            [ngStyle]="{ 'visibility': currentPage === 1 ? 'hidden' : 'visible' }"
                            class="stage-button prev-stage"
                            id="prevStageButton"
                            type="button"
                    >
                        <span><</span>
                        <span>Previous</span>
                    </button>
                    <!-- Regular Next Button: Show on all pages except last, and not on payment page when payment is required -->
                    <button
                            (click)="goToNextStage()"
                            [ngClass]="{ 'd-none': currentPage === pages.length || (paymentStepRequired && !customerHasCreditCard && currentPage === 4) }"
                            class="stage-button next-stage"
                            id="nextStageButton" type="button"
                    >
                        <span>Next</span>
                        <span>></span>
                    </button>
                    <!-- Payment Next Button: Show only on payment page (page 4) when payment is required and customer doesn't have credit card -->
                    <button
                            (click)="submitPaymentMethod()"
                            class="stage-button next-stage"
                            [ngClass]="{ 'd-none': !(paymentStepRequired && !customerHasCreditCard && currentPage === 4) }"
                            id="paymentStageButton"
                            type="button"
                    >
                        <span>Next</span>
                        <span>
                            <span class="icon-span" *ngIf="!paymentMethodAddInProgress">></span>
                            <div class="spinner" *ngIf="paymentMethodAddInProgress">
                                <div class="dot"></div>
                                <div class="dot"></div>
                                <div class="dot"></div>
                            </div>
                        </span>
                    </button>
                    <!-- Submit Button: Show only on last page -->
                    <button
                            (click)="submit()"
                            [disabled]="!signatureControls.agree.value"
                            [ngClass]="{ 'd-none': currentPage !== pages.length }"
                            class="stage-button order-booking-button d-none"
                            id="orderBookingStageButton"
                            type="button"
                    >
                        <span>{{ bookingInProgress ? 'Please Wait...' : 'Book My Order' }}</span>
                        <span>
                            <span class="icon-span" *ngIf="!bookingInProgress">></span>
                            <div *ngIf="bookingInProgress" class="spinner">
                                <div class="dot"></div>
                                <div class="dot"></div>
                                <div class="dot"></div>
                            </div>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <app-order-summary
        *ngIf="showSummary"
        [orderId]="opportunity!.id"
        [orderType]="'original'"
        [alreadyBookedOrder]="alreadyBookedOrder"
    ></app-order-summary>

</div>
